import fp from 'lodash/fp';
import { createSelector } from 'reselect';
import toArrayWithQuantity from '../../../../helpers/toArrayWithQuantity';

export const getInventoryItem = fp.get('inventory.item');

export const getAll = createSelector(getInventoryItem, fp.get('all'));

export const getAllValues = createSelector(getAll, toArrayWithQuantity);

export const getItemForId = createSelector((_, id) => id, getAll, fp.get);

export const getIsFetching = createSelector(
  getInventoryItem,
  fp.get('fetching')
);
export const getIsFetched = createSelector(getInventoryItem, fp.get('fetched'));
export const getFetchingError = createSelector(
  getInventoryItem,
  fp.get('fetchingError')
);

export const getIsSaving = createSelector(getInventoryItem, fp.get('saving'));
export const getIsSaved = createSelector(getInventoryItem, fp.get('saved'));
export const getSavingError = createSelector(
  getInventoryItem,
  fp.get('savingError')
);

export const getIsDeleting = createSelector(
  getInventoryItem,
  fp.get('deleting')
);
export const getIsDeleted = createSelector(getInventoryItem, fp.get('deleted'));
export const getDeletingError = createSelector(
  getInventoryItem,
  fp.get('deletingError')
);

export const getOrder = createSelector(getInventoryItem, fp.get('order'));
